<div class="pt-2 pb-3 pr-2 display-flex justify-content-end align-items-center">
  <button class="pagination-button border-0 bg-white d-inline-flex justify-content-center align-items-center border-rounded cursor-pointer text-center p-2 line-height-1 font-weight-bolder m-0 color-se-gray"
    [ngClass]="{'visibility-hidden': paginationPageNumber <= 2}"
    [disabled]="paginationPageNumber <= 1"
    (click)="goToFirstPage()">
    <img alt="" src="/assets/images/arrow5_edge.svg" class="rotate-180">
  </button>
  <button class="pagination-button border-0 bg-white d-inline-flex justify-content-center align-items-center border-rounded cursor-pointer text-center pb-1 line-height-1 font-weight-bolder m-0 color-se-gray"
    [ngClass]="{'visibility-hidden': paginationPageNumber <= 1}"
    [disabled]="paginationPageNumber <= 1"
    (click)="decrementPaginationPage()">
    <i class="font-size-32 se-icon-arrow2_left arrow-up-top cursor-pointer"></i>
  </button>
  @if (paginationItemsPerPageDisplayValue !== allItemsSelectedValue) {
    <div class="px-2 color-se-dark-gray font-weight-bold border border-top-0 border-left-0 border-right-0 pagination-page-number">{{ paginationPageNumber }}</div>
  }
  <button class="pagination-button border-0 bg-white d-inline-flex justify-content-center align-items-center border-rounded cursor-pointer text-center pb-1 line-height-1 font-weight-bolder m-0 color-se-gray"
    [ngClass]="{'visibility-hidden': paginationPageNumber >= paginationMaxPagesNumber}"
    [disabled]="paginationPageNumber >= paginationMaxPagesNumber"
    (click)="incrementPaginationPage()">
    <i class="font-size-32 se-icon-arrow2_right arrow-up-top cursor-pointer"></i>
  </button>
  <button class="pagination-button border-0 bg-white d-inline-flex justify-content-center align-items-center border-rounded cursor-pointer text-center p-2 line-height-1 font-weight-bolder m-0 color-se-gray"
    [ngClass]="{'visibility-hidden': paginationPageNumber >= paginationMaxPagesNumber}"
    [disabled]="paginationPageNumber >= paginationMaxPagesNumber"
    (click)="goToLastPage()">
    <img alt="" src="/assets/images/arrow5_edge.svg">
  </button>
  <div class="pagination-items-per-page display-flex align-items-center pl-1">
    <span i18n="@@app.items_per_page" class="px-1 font-size-s">Items per page</span>:
    <ng-select
      class="ng-select-pagination font-size-s"
      dropdownPosition="top"
      [items]="paginationLevels"
      bindLabel="label"
      bindValue="value"
      [clearable]="false"
      [searchable]="false"
      [ngModel]="paginationItemsPerPageDisplayValue"
      (ngModelChange)="changePaginationItemsPerPage($event)">
    </ng-select>
  </div>
</div>
